import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-manage-profiles',
    templateUrl: './manage-profiles.component.html',
    styleUrls: ['./manage-profiles.component.css'],
    standalone: false
})
export class ManageProfilesComponent implements OnInit {

  role
  customers: []
  experts: []
  serverErrorMessages: string
  loading: boolean = true;
  closeResult;
  customerForm = new FormGroup({
    email: new FormControl('', [Validators.email]),
    contactNumber: new FormControl('', [Validators.maxLength(10), Validators.minLength(10)]),
    pContactNumber: new FormControl('', [Validators.maxLength(10), Validators.minLength(10)]),
    pEmail: new FormControl('', [Validators.email]),
    gstNumber: new FormControl('11AAAAA0000A1Z5',
    [Validators.required,
     Validators.minLength(15),
     Validators.maxLength(15)
    ]),
    PAN: new FormControl('AAAAA0000A',
    [Validators.required,
     Validators.minLength(10),
     Validators.maxLength(10)
    ]),
    currency: new FormControl('',
    [Validators.required
    ]),
    bankName: new FormControl('',
    [Validators.required
    ]),
    bankAccountNumber: new FormControl('',
    [Validators.required
    ]),
    IFSC: new FormControl('',
    [Validators.required,
    Validators.minLength(11),
    Validators.maxLength(11)
    ]),
    SWIFT: new FormControl('',
    [Validators.required,
     Validators.minLength(11),
     Validators.maxLength(11)
    ])
  })

  
  expertForm = new FormGroup({
    email: new FormControl('', [Validators.email]),
    contactNumber: new FormControl('', [Validators.maxLength(10), Validators.minLength(10)]),
  })
  customerID;
  expertID;
  constructor(private loginService: LoginService,private router : Router, private moderatorService: ModeratorService, private modalService: NgbModal) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllCustomers();
          this.getAllExperts()
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  getAllCustomers(){
    this.moderatorService.getAllCustomer().subscribe(
      res=>{
       //console.log('got all customers', res)
        this.customers = res['customers']
      },
      err=>{
       //console.log('error while getting all customers', err)
      }
    )
  }
  getAllExperts(){
    this.moderatorService.getAllExperts().subscribe(
      res => {
        this.experts = res['techExperts']
       //console.log('Got Experts', this.experts)
      },
      err => {
        this.serverErrorMessages = err.erros.message
       //console.log('error getting experts', err)
      }
    )
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  openCustomer(content, customerID) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.customerID = customerID
     //console.log('got customer id', this.customerID)
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  openExpert(content, expertID) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.expertID = expertID
     //console.log('got customer id', this.expertID)
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  deleteCustomer(customerID){
   //console.log('deleting customer', customerID)
    this.moderatorService.deleteProfile({userId: customerID}).subscribe(
      res => {
       //console.log('deleted', res)
        alert(res['message'])
        window.location.reload()
      },
      err => {
       //console.log('error deleting');
        this.serverErrorMessages = err.error.message
        alert(this.serverErrorMessages)
      }
    )
  }

  deleteExpert(expertID){
   //console.log('deleting expert', expertID)
    this.moderatorService.deleteProfile({userId: expertID}).subscribe(
      res => {
       //console.log('deleted', res)
        alert(res['message'])
        window.location.reload()
      },
      err => {
       //console.log('error deleting');
        this.serverErrorMessages = err.error.message
        alert(this.serverErrorMessages)
      }
    )
  }

  editCustomer(){
   //console.log('editing customer', this.customerForm)
    this.moderatorService.editProfile({...this.customerForm.value, _id:this.customerID}).subscribe(
      res => {
       //console.log('edit success', res)
        alert(res['message'])
        window.location.reload()
      },
      err => {
       //console.log('err', err)
      }
    )
  }

  editExpert(){
   //console.log('editing expert', this.expertForm)
    this.moderatorService.editProfile({...this.expertForm.value, _id:this.expertID}).subscribe(
      res => {
       //console.log('edit success', res)
        alert(res['message'])
        window.location.reload()
      },
      err => {
       //console.log('err', err)
      }
    )
  }

}
